import DemoService from "../../service/demo_service"
import uniq from "../../utilities/unique_values"
import Connector from "../connector"
import { IHostCard } from "../types"
import { IDynamoConnector, IDynamoConnectorProps } from "./types"

class DynamoConnector extends Connector implements IDynamoConnector {
    constructor(props: IDynamoConnectorProps) {
        const { id, descriptor, serviceHost } = props
        super({ id, descriptor, serviceHost })
    }

    public getCards(text: string) {
        const load = async () => {
            const data = await this.getServiceData(text)
            const allEntityItems = data
                .map((d) => d.entityItems)
                .flat(1)
            const cards = uniq<IHostCard<any>>(
                allEntityItems,
                (item) => item.id,
            )
            return cards
                .map((card) => Object.assign(
                    {},
                    card,
                    {
                        color: this.descriptor.color,
                        connectorId: this.descriptor.id,
                        connectorName: this.descriptor.name,
                    },
                ))
        }
        return load()
    }

    public getServiceData(text: string) {
        const load = async () => {
            return await DemoService(text, "dynamo")
        }
        return load()
    }
}

export default DynamoConnector
